import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import router from '../router'
import db from '../firebase/init'
// import loginForm from '../components/auth/LoginForm'

const actions = {
  signUpAction({ commit, dispatch }, payload) {
    commit("toggleLoadingPage")
    firebase
      .auth()
      .createUserWithEmailAndPassword(payload.email, payload.password)
      .then(cred => {
        // console.log('criou user')

        // db.collection('usuarios')
        //   .doc(payload.email)
        //   .set({
        //     email: payload.email,
        //     tsCadastro: Date.now()
        //   })
        //   .then(() => {
            console.log('adicionou ao banco')
            dispatch('loginAction', payload)
            db.collection('pre-insc4').doc(payload.email).update({ checked: true })
            
            commit('setEmailChecked', false)
          // })
          // commit("toggleLoadingPage")
      }).catch(err => {
        commit("toggleLoadingPage")
        console.log('deu erro' + err.message)
        commit("setError", err.message)
        commit(
          "setFeedback",
          {
            show: true,
            message: err.message,
            btnTxt: 'OK',
            color: 'red',
            textColor: 'white--text'
          }
        )
      })

  },
  loginAction({ commit, dispatch, getters }, payload) {
    commit("toggleLoadingPage")
    firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(cred => {
          // this.checkAdminToken(cred)
          
          commit('setUser', cred.user)
          dispatch('checkAdminToken', payload)
          db.collection('usuarios')
            .doc(cred.user.email)
            .get()
            .then((doc) => {
              let u = doc.data()
              commit("setUser", u)
              // u.isAdmin ? commit("setAdminToken", true) : commit("setAdminToken", false)
              if(getters.getAdminToken){
                router.push ({ name: 'admin'})
                // commit("setAdminToken", true)
              } else{
                router.push('/')
                // commit("setAdminToken", false)
              }
              commit("toggleLoadingPage")
            })
          // commit("setUser", cred.user)
          // cred.user.getIdTokenResult().then(idTokenResult => {
          //   let isAdmin = idTokenResult.claims.admin
          //   if(isAdmin){
          //     router.push ({ name: 'admin'})
          //     commit("setAdminToken", true)
          //   } else{
          //     router.push('/')
          //     commit("setAdminToken", false)
          //   }
          //   commit("toggleLogin")
          // })

        })
        .catch(err => {
          commit("toggleLoadingPage")
          commit("setError", err.message)
          // loginForm.$emit('error', err.message)
          commit(
            "setFeedback",
            {
              show: true,
              message: err.message,
              btnTxt: 'OK',
              color: 'red',
              textColor: 'white--text'
            }
          )
          // this.error = true
        })
  },
  signOutAction({ commit }) {
    commit("toggleLoadingPage")
    firebase
      .auth()
      .signOut()
      .then(() => {
        commit("setUser", null);
        commit("setEmailChecked", false)
        commit("toggleLoadingPage")
        router.push({ name: 'login' })
        window.sessionStorage.clear();
      })
      .catch(error => {
        commit("toggleLoadingPage")
        commit("setError", error.message);
      });
  },
  checkEmailAction({ commit }, payload) {
    let ref = db.collection('pre-insc4')

    ref.doc(payload.email)
      .get()
      .then((doc) => {
        if(doc.exists) {
          let data = doc.data()
          data.checked ? commit("setEmailChecked", 2) : commit("setEmailChecked", 1)

        } else {
          commit("setEmailChecked", false)
          commit(
            "setFeedback",
            {
              show: true,
              message: "O email informado não consta em nosso cadastro",
              // btnTxt: 'OK',
              color: 'green lighten-5',
              textColor: 'black--text'
            }
          )
        }
      })

  },
  retrieveAction({ commit }, payload){
    // if(this.email){
      commit("toggleLoadingPage")
      firebase.auth().sendPasswordResetEmail(payload.email)
        .then(() => {
          commit("setFeedback", {
              show: true,
              message: "O link para resetar sua senha foi enviado para seu email cadastrado",
              // btnTxt: 'OK',
              color: 'green',
              textColor: 'white--text'
          })
        })
        .catch(err => {
          commit("setFeedback", {
            show: true,
            message: err.message,
            btnTxt: 'OK',
            color: 'red',
            textColor: 'white--text'
          })
        })
        commit("toggleLoadingPage")
    // } else {
    //   commit("setFeedback", {
    //     show: true,
    //     message: 'Todos os campos devem ser preenchidos',
    //     btnTxt: 'OK',
    //     color: 'amber',
    //     textColor: 'black--text'
    //   })
    // }

  },
  updateUserAction({ commit }, payload) {
    db.collection('usuarios')
      .doc(payload.email)
      .get()
      .then((doc) => {
        let u = doc.data()
        commit("setUser", u)
      })
  },
  checkAdminToken({ commit }, payload) {
    db.collection('usuarios')
      .doc(payload.email)
      .get()
      .then((u) => {
        let doc = u.data()
        // console.log(doc.admin ? 'é admin' : 'ñ é admin')
        if(doc.admin) {
          commit('setAdminToken', true)
        } else {
          commit('setAdminToken', false)
        }
      })
    // payload.user.getIdTokenResult().then(idTokenResult => {
    //   let isAdmin = idTokenResult.claims.admin
    //   if(isAdmin){
    //     this.$router.push ({ name: 'admin'})
    //   } else{
    //     this.$router.push('/')
    //   }
    //   this.$emit('loggedIn')
    //   this.email = null
    //   this.password = null
    // })
  },
  toggleGoLiveAction({ commit, state, getters }) {
    // console.log(payload)
    db.collection('videos')
      .doc(state.video.videoId)
      .update({
        golive: getters.getVideo.golive
      })
    // commit("toggleGoLive")
  },
  watchGoLiveAction({ commit, state, getters }) {
    // console.log(state.video.videoId);
    let id = state.video.videoId;
    let q;
    db.collection('videos')
      .doc(id)
      .onSnapshot((snapshot) => {
        q = snapshot.data()
        commit("setGoLive", q.golive)
        // golive: getters.getVideo.golive
      })
      
      // console.log('ola: ' + q.golive)
    // commit("toggleGoLive")
  },
  getVideoAction({ commit }){
    db.collection('videos')
      .onSnapshot(snapshot => {
        snapshot.docs.forEach(doc => {
          let video = doc.data()
          video.videoId = doc.id
          
          if(video.display){
            // this.getComments(doc.id)
            // this.video = video
            commit("setVideo", video)
            // console.log(video.data.toDate())
            // let storageRef = firebase.storage().ref();
            // let logoRef = storageRef.child('logos')
            // if(video.patrocinio){
            //   this.patrocinio = []
            //   video.patrocinio.forEach(patrocinador => {
            //     let pat = logoRef.child(patrocinador)
            //     pat.getDownloadURL().then(pt => {
            //       this.patrocinio.push(pt)
            //     })
            //   })
            // }else if(video.sponsors){
            //   this.sponsors = []
            //   video.sponsors.forEach(sponsor => {
            //     let spn = logoRef.child(sponsor)
            //     spn.getDownloadURL().then(s => {
            //       this.sponsors.push(s)
            //     })
            //   })
            // }

          } else{
            // console.log('video sem display')
            // this.videos.push(video)
          }

        });
      });
  },
  async addPreInsc({ commit }, payload){
    commit('toggleLoadingPage')
    // console.log(payload)

    // const response = await db.collection('cc22').doc(payload.email)
    const response = await db.collection(payload.cursoID).doc(payload.email)
      .set(payload)
      .then(() => {
        commit('toggleLoadingPage')
        return true
      })
      .catch((e) => {
        console.error('addPreInsc erro: ', e.message)
        commit('toggleLoadingPage')
        return false
      })
    return response
  }
};

export default actions;